import classNames from 'classnames'
import React from 'react'

import Button from '@/components/Button'
import Image from '@/components/Image'
const RessourceLink = ({heading, content, button, badge, badgeColor = 'turquoise', image}) => {
  return (
    <div className='relative hidden flex-col gap-4 rounded-lg bg-violet-200 p-2 pb-4 lg:mb-4 lg:flex'>
      <div
        className={classNames(
          'misc-button-s fit-content absolute -top-3 left-1/2 flex -translate-x-1/2 rotate-6 rounded-lg px-2 py-1 uppercase',
          {
            'bg-purple-400 text-white': badgeColor === 'purple' || badgeColor === '',
            'text-purple-700 bg-turquoise-400': badgeColor === 'turquoise',
            'bg-violet-400': badgeColor === 'violet',
            'bg-yellow-400 text-purple-900': badgeColor === 'yellow',
          }
        )}
      >
        {badge}
      </div>
      <div className='overflow-hidden rounded-s'>
        <Image {...image} sizes={{sm: '100', md: '50'}} fitIn />
      </div>
      <div className='flex flex-col gap-2 px-2'>
        <div className='body-s-medium'>{heading}</div>
        <div className='body-xs-regular text-purple-400'>{content}</div>
      </div>
      <Button label={button[0].label} link={button[0].link} size='small' theme='secondary' />
    </div>
  )
}

export default RessourceLink
